/**
 * Git backup domain — mirrors `data/library/` to a remote music repo.
 * App is source of truth; pull only when remote is newer than local mutations.
 */
import { z } from "zod";
export const GitSyncDirectionSchema = z.enum(["idle", "pulling", "pushing"]);
export const GitSyncStatsSchema = z.object({
    added: z.number().int().nonnegative(),
    removed: z.number().int().nonnegative(),
    pushed: z.number().int().nonnegative().default(0),
    restored: z.number().int().nonnegative().default(0),
});
export const GitSyncStatusSchema = z.object({
    syncing: z.boolean(),
    direction: GitSyncDirectionSchema.default("idle"),
    lastSync: z.number().int().nullable(),
    lastBackup: z.number().int().nullable(),
    lastRestore: z.number().int().nullable(),
    lastMutation: z.number().int().nullable(),
    pendingBackup: z.boolean().default(false),
    lastError: z.string().nullable(),
    stats: GitSyncStatsSchema,
    configured: z.boolean(),
});
export const GitSyncEventSchema = z.discriminatedUnion("type", [
    z.object({ type: z.literal("start") }),
    z.object({ type: z.literal("clone") }),
    z.object({ type: z.literal("pull") }),
    z.object({ type: z.literal("push") }),
    z.object({ type: z.literal("scan") }),
    z.object({ type: z.literal("added"), owner: z.string(), filename: z.string() }),
    z.object({ type: z.literal("updated"), owner: z.string(), filename: z.string() }),
    z.object({ type: z.literal("removed"), owner: z.string(), filename: z.string() }),
    z.object({ type: z.literal("committed"), message: z.string() }),
    z.object({ type: z.literal("noop") }),
    z.object({
        type: z.literal("complete"),
        added: z.number().int(),
        removed: z.number().int(),
        pushed: z.number().int().default(0),
        restored: z.number().int().default(0),
    }),
    z.object({ type: z.literal("error"), message: z.string() }),
]);
//# sourceMappingURL=gitSync.js.map